var React = require('react');

function ArrowDownHeaderInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"rgba(27,32,50,0.8)","d":"M102.428 5.289l-4.139 4.139a.674.674 0 0 1-.953-.953L101 4.813 97.336 1.15a.674.674 0 0 1 .953-.95l4.139 4.139a.674.674 0 0 1 0 .953z","transform":"rotate(90 53.382 -43.757)"}));
}

ArrowDownHeaderInline.defaultProps = {"width":"9.626","height":"5.487","viewBox":"0 0 9.626 5.487"};

module.exports = ArrowDownHeaderInline;

ArrowDownHeaderInline.default = ArrowDownHeaderInline;
